var sectionHide = document.querySelectorAll('.section__hide')
var section = document.querySelectorAll('.section__collapse')

sectionHide.forEach(function(el) {
    el.addEventListener('click', function() {
        collapse(el)
    })

    el.addEventListener("keydown", function (e) {
        if (e.code === "Enter") { 
            collapse(el)
        }
    })
})


function calcHeight() {
    section.forEach(function(e) {
        var height = e.offsetHeight
        e.style.maxHeight = height + 1 + 'px'
    })
}

function collapse(e) {
    var sectionCollapse = e.closest('.section').querySelector('.section__collapse')

    e.classList.toggle('active')
    sectionCollapse.classList.toggle('collapse')
}

calcHeight()